<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q7nD7z/tc-custom/9781452156712.jpg?1737761272376" alt="This image is the cover for the book Rachel Khoo's Kitchen Notebook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rachel Khoo's Kitchen Notebook
      </h1>
      <p class="bookDescription body article font2">
        <b>An inspiring, intimate cookbook with kitchen notes and photos from the BBC and Food Network chef.</b><br/><br/>Rachel Khoo—bestselling author, BBC and Food Network personality, and international tastemaker—offers a constellation of ideas and creative inspiration in this exuberant more-than-a-cookbook. Each page offers doable and delicious recipes, style-setting ideas from around the globe, and Rachel’s charming illustrations and engaging notes. <br/><br/>With 250 photographs, it’s a delightful companion for cooks that will brings surprises and smiles as well as scrumptious food. Learn to make:<br/><br/>Roasted Cauliflower and Caraway Salad * Speedy Chorizo and Chickpea Stew * Teriyaki Salmon Steamed Buns * Bread-Wrapped Lamb Kebabs * Potato Crumpets with Maple Mustard Glaze * Dark Chocolate and Cherry Cookies * Lemon Lava Cakes * and many more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Khoo
      </h2>
      
      <p class="authorDescription body article">Rachel Khoo is the host of the popular television series The Little Paris Kitchen and a columnist for the London Evening Standard. She divides her time between Paris and London.David Loftus is a London-based food and lifestyle photographer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6451bc06